module.exports = __webpack_public_path__ + "static/img/aqzs22.53589a00.jpg";